<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="claimPage">
            <h1>{{ 'footer.infoSecurity.title' | translate }}</h1>
            <div>
                {{
                    'footer.infoSecurity.infoSecurityPolicy.introduction'
                        | translate
                }}
            </div>
            <div>
                {{ 'footer.infoSecurity.infoSecurityPolicy.scope' | translate }}
            </div>
            <div>
                {{
                    'footer.infoSecurity.infoSecurityPolicy.managementCoverage'
                        | translate
                }}
            </div>
            <div class="mb-2">
                {{
                    'footer.infoSecurity.infoSecurityPolicy.policyStatement'
                        | translate
                }}
            </div>

            <ol>
                <li>
                    {{
                        'footer.infoSecurity.infoSecurityPolicy.objectives.secureEnvironment'
                            | translate
                    }}
                </li>
                <li>
                    {{
                        'footer.infoSecurity.infoSecurityPolicy.objectives.confidentiality'
                            | translate
                    }}
                </li>
                <li>
                    {{
                        'footer.infoSecurity.infoSecurityPolicy.objectives.integrity'
                            | translate
                    }}
                </li>
                <li>
                    {{
                        'footer.infoSecurity.infoSecurityPolicy.objectives.businessContinuity'
                            | translate
                    }}
                </li>
                <li>
                    {{
                        'footer.infoSecurity.infoSecurityPolicy.objectives.compliance'
                            | translate
                    }}
                </li>
                <li>
                    {{
                        'footer.infoSecurity.infoSecurityPolicy.objectives.personalDataProtection'
                            | translate
                    }}
                </li>
                <li>
                    {{
                        'footer.infoSecurity.infoSecurityPolicy.objectives.privacyManagement'
                            | translate
                    }}
                </li>
                <li>
                    {{
                        'footer.infoSecurity.infoSecurityPolicy.objectives.riskAssessment'
                            | translate
                    }}
                </li>

                <!-- <li>
					資安政策：
					<br />
					<ul>
						<li>
							本公司員工，均須簽署本公司「保密同意書」，外部各方參加本公司專案人員均須簽署「相互保密合約書」，並遵守「國家機密保護法」、「營業秘密法」、「個人資料保護法」、「著作權法」、「刑法」、「資通安全管理法」、「資通安全管理法施行細則」及資通安全管理法子法等國家相關法規之要求，且不得發生洩密或違法事件。
						</li>
						<li>
							委製、共同合作或專案資料之存取或異動，專案檔案均應設置存取權限，敏感（機密）資訊傳輸前必須先行加密。
						</li>
					</ul>
				</li> -->
            </ol>
        </div>
    </div>
</div>
<app-footer></app-footer>
